<template>
  <section>
    <p v-if="!withoutLabel"><b>{{data.label}}: </b></p>
    <table class="table table-sm table-grid table-responsive-md">
      <tbody>
        <tr v-for="(position, positionIndex) in data.value" v-bind:key="'customField-' + positionIndex">
          <td>{{position.name}}</td>
          <td>{{position.quantity}} {{position.measureName}}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
export default {
  name: 'itemsCollectionCustomFieldValues',
  props: {
    data: {},
    withoutLabel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>
